import { render } from "./autoLimitTransport.vue?vue&type=template&id=366149e0&scoped=true"
import script from "./autoLimitTransport.vue?vue&type=script&lang=js"
export * from "./autoLimitTransport.vue?vue&type=script&lang=js"

import "./autoLimitTransport.vue?vue&type=style&index=0&id=366149e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366149e0"]])

export default __exports__